/*
 * Copyright (c) by INFODATA-GROUP. All rights reserved.
 * No part of this publication may be reproduced, distributed,
 * or transmitted in any form or by any means, including photocopying, recording,
 * or other electronic or mechanical methods, without the prior written permission of the publisher,
 * except in the case of brief quotations embodied in critical
 * reviews and certain other noncommercial uses permitted by copyright law.
 *  author : vhe
 *  date : 02/03/2021 07:39
 */

import { Serializable } from '../../db/serializable';

export class StorageRequest implements Serializable {
  public url: string;
  public method: 'GET' | 'OPTIONS';
  public token: string;
  public content: any | any[];
  public stamp: Date;
  constructor(
    url: string,
    method: 'GET' | 'OPTIONS',
    token: string,
    content: any | any[],
    stamp: Date
  ) {
    this.url = url;
    this.method = method;
    this.token = token;
    this.content = content;
    this.stamp = stamp;
  }

  serialize(): any {
    return {
      url: this.url,
      method: this.method,
      token: this.token,
      content: this.content,
      stamp: this.stamp.getTime(),
    };
  }

  setId(id: any) {
    void id;
  }
}
